import { useEffect, useRef } from 'react';

export default function AnimatedBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animId;

    const blobs = [
      { x: 100, y: 80,  vx: 1.2,  vy: 0.7,  r: 380, rgb: '160,162,158', a: 0.9  },
      { x: 600, y: 300, vx: -0.9, vy: -1.1, r: 360, rgb: '130,132,129', a: 0.85 },
      { x: 400, y: 50,  vx: 0.6,  vy: 1.4,  r: 320, rgb: '200,200,198', a: 0.8  },
      { x: 200, y: 380, vx: 1.1,  vy: -0.8, r: 340, rgb: '45,45,43',    a: 0.75 },
      { x: 700, y: 100, vx: -1.3, vy: 0.9,  r: 300, rgb: '153,155,152', a: 0.85 },
      { x: 50,  y: 250, vx: 0.8,  vy: -1.2, r: 320, rgb: '60,55,50',    a: 0.7  },
    ];

    const resize = () => {
      canvas.width  = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const tick = () => {
      const w = canvas.width;
      const h = canvas.height;

      ctx.fillStyle = '#b8bab7';
      ctx.fillRect(0, 0, w, h);

      blobs.forEach((b) => {
        const g = ctx.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.r);
        g.addColorStop(0,   `rgba(${b.rgb}, ${b.a})`);
        g.addColorStop(0.6, `rgba(${b.rgb}, ${b.a * 0.3})`);
        g.addColorStop(1,   `rgba(${b.rgb}, 0)`);

        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, w, h);
        ctx.globalCompositeOperation = 'source-over';

        b.x += b.vx;
        b.y += b.vy;

        if (b.x < -b.r || b.x > w + b.r) b.vx *= -1;
        if (b.y < -b.r || b.y > h + b.r) b.vy *= -1;
      });

      animId = requestAnimationFrame(tick);
    };

    tick();

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        display: 'block',
      }}
    />
  );
}
